export enum ContentfulContentArticleTemplate {
  CARD_OFFER = 'card offre',
  CARD_FORMULE = 'card formule',
  CARD_BULLE = 'card icon bulle',
  CARD_IMAGE = 'card image',
  CARD_IMAGE_FULL = 'card image full',
  CARD_STAGE = 'card etapier',
  REFRESH_IMAGE_FULL = 'refresh image full',
  REFRESH_CARD_PICTO = 'refresh card picto',
  REFRESH_IMAGE_BENTO = 'refresh image bento',
  REFRESH_CARD_STAGE = 'refresh card etapier',
  REFRESH_PICTO = 'refresh picto',
  RECOMMENDATION = 'recommendation', // Doesnt exist yet
  REFRESH_DEFAULT = 'refresh default',
  REFRESH_CARD_PICTO_ALIGN_LEFT = 'refresh card picto ferré à gauche',
  UNIFICATION_TRANSPARENT_CARDS = 'unification cartes transparentes',
  DEFAULT = 'default',
}
